import { GraphQLClient } from 'graphql-request';

const client = new GraphQLClient('https://graphql.datocms.com/', {
  headers: {
    authorization: 'd427528257ae84ea4da1a518667eb1',
  },
});

export default client;
